import crudAction from './actions'

export default {
  name: 'externalLeadSources',
  namespace: 'external_lead_sources',
  methods: [
    ...crudAction,
  ]
}
